import { Check } from 'lucide-react';
import { cn } from '../../../util/EnvironmentConfig';

export function Stepper({ steps, currentStep }) {
  return (
    <div className="flex items-center justify-center w-full mb-8">
      {steps.map((step, index) => {
        const isCompleted = currentStep > index + 1;
        const isCurrent = currentStep === index + 1;

        return (
          <div key={step} className="flex items-center">
            <div className="flex flex-col items-center relative">
              <div
                className={cn(
                  'w-10 h-10 rounded-full flex items-center justify-center border-2 font-bold transition-all duration-300 z-10 bg-slate-900',
                  isCompleted
                    ? 'bg-blue-600 border-blue-600 text-white'
                    : isCurrent
                      ? 'border-blue-600 text-blue-600 shadow-[0_0_15px_rgba(37,99,235,0.3)]'
                      : 'border-slate-700 text-slate-500',
                )}
              >
                {isCompleted ? <Check className="w-5 h-5" /> : index + 1}
              </div>
              <span
                className={cn(
                  'absolute -bottom-6 text-sm font-medium whitespace-nowrap transition-colors duration-300',
                  isCurrent
                    ? 'text-blue-600'
                    : isCompleted
                      ? 'text-slate-300'
                      : 'text-slate-500',
                )}
              >
                {step}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={cn(
                  'w-24 h-[2px] mx-2 transition-colors duration-300',
                  isCompleted ? 'bg-blue-600' : 'bg-slate-700',
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
